import script from "./HeaderMenuRender.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderMenuRender.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderMenuRender.vue?vue&type=style&index=0&id=4647d641&lang=css"

const __exports__ = script;

export default __exports__